module.exports = __webpack_public_path__ + "img/75a37480-033b-4871-ae2e-ff6c8ec0ed89.a1e6f13f.jpg";